import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type PaymentResult = 'success' | 'cancel';

const STORAGE_KEYS = {
  result: 'paymentResult',
  type: 'paymentType',
} as const;

export function PaymentResultHandler() {
  const { t } = useTranslation('billing');
  const [open, setOpen] = React.useState(false);
  const [result, setResult] = React.useState<PaymentResult | null>(null);

  React.useEffect(() => {
    const storedResult = sessionStorage.getItem(STORAGE_KEYS.result) as PaymentResult | null;
    if (storedResult === 'success' || storedResult === 'cancel') {
      setResult(storedResult);
      setOpen(true);
      // Clean up immediately so refresh won't re-open
      sessionStorage.removeItem(STORAGE_KEYS.result);
      sessionStorage.removeItem(STORAGE_KEYS.type);
    }
  }, []);

  if (!result) return null;

  const isSuccess = result === 'success';

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md design-card border-white/20">
        <DialogHeader>
          <DialogTitle className="design-text-primary text-xl">
            {isSuccess ? t('result.successTitle') : t('result.cancelTitle')}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="design-text-secondary">
          {isSuccess ? t('result.successDescription') : t('result.cancelDescription')}
        </DialogDescription>
        <div className="mt-token-md flex justify-end">
          <Button onClick={() => setOpen(false)} variant={isSuccess ? 'default' : 'secondary'}>
            {t('common:buttons.close')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default PaymentResultHandler;


